export enum VariableTypeEnum {
  TEXT = 'text',
  NUMBER = 'number',
  DATE = 'date',
  TIME = 'time',
  EMAIL = 'email',
  PHONE = 'phone',
  DROPDOWN = 'dropdown',
  LIST = 'list',
  BOOLEAN = 'boolean',
  TEXTAREA = 'textarea',
}

export enum ListConfigItemTypeEnum {
  TEXT = 'text',
  NUMBER = 'number',
  EMAIL = 'email',
  PHONE = 'phone',
}

export interface DropdownOption {
  label: string
}

export interface ListConfig {
  separator: string
  itemType: ListConfigItemTypeEnum
}

export interface ConditionalRule {
  condition: string
}

export interface SurgeryReportField {
  id: string
  name: string
  label: string
  type: VariableTypeEnum
  dropdownOptions: DropdownOption[]
  listConfig: ListConfig
  required: boolean
  order: number
}

export interface SurgeryReportSection {
  id: string
  title: string
  order: number
  fields: SurgeryReportField[]
}

export interface SurgeryReportVisibilityCondition {
  id: string
  name: string
  description: string
}

export enum ReferralPhysicianAndSurgeonRequirementEnum {
  REFERRAL_PHYSICIAN_REQUIRED = 'referral physician required',
  SURGEON_REQUIRED = 'surgeon required',
}

export interface SurgeryReportTemplate {
  id: string
  name: string
  sections: SurgeryReportSection[]
  physicianNeeded: boolean
  visibilityConditions: SurgeryReportVisibilityCondition[]
  acceptsAttachments: boolean
  referralPhysicianAndSurgeonRequirement: ReferralPhysicianAndSurgeonRequirementEnum | null
}

export interface OrganizationSurgeryReportsResponse {
  reports: SurgeryReportTemplate[]
}

export interface SurgeryReportFieldFormData {
  fieldId: string
  fieldName: string
  value: string | number | string[] | boolean
  required: boolean
  type: VariableTypeEnum
}

export interface SurgeryReportSectionFormData {
  sectionId: string
  title: string
  fields: SurgeryReportFieldFormData[]
}

export interface SurgeryReportFormData {
  templateId: string
  templateName: string
  sections: SurgeryReportSectionFormData[]
  metadata?: {
    createdAt?: Date
    createdBy?: string
    procedureId?: string
  }
}

export interface FieldValidationResult {
  fieldId: string
  isValid: boolean
  errorMessage?: string
}

export interface FormValidationResult {
  isValid: boolean
  fieldResults: FieldValidationResult[]
  generalErrors: string[]
}
